import { EntityId } from "@/shared/types/entity-id";
import { Kind } from "@/services/backend/samples/types/kind";
import { v4 } from "uuid";
import { SampleViewModel } from "@/services/backend/samples/types/sample-view-model";
import { UUID } from "@bitory-gmbh/nidavellir";

export interface Delivery {
  id: string;
  documentId: string;
  documentNamespace: string;
  trackingId: string;
  description: string;
  labId: EntityId;
  items: Item[];
  sent: boolean;
  sentAt: string;
  cancelled: boolean;
  cancelledAt: string;
  createdAt: string;
  updatedAt: string;
}

export interface Item {
  id: string;
  deliveryId: string;
  kind: Kind;
  sampleId: string;
  cancelled: boolean;
}

export function newItemFrom(s: SampleViewModel, deliveryId: UUID): Item {
  return {
    id: v4(),
    deliveryId,
    kind: s.kind,
    sampleId: s.id,
    cancelled: false,
  };
}

export function containsSampleId(
  delivery: Delivery,
  sampleId: string,
): boolean {
  return delivery.items.some((item) => item.sampleId === sampleId);
}
